module.exports = __webpack_public_path__ + "static/media/helping-others-large.d48c93f4.png";